import LoadCard from './load-card';

export default LoadCard;
